(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
  var checkbox = document.getElementById('agree-checkbox');
  var addToCartButton = document.getElementById('add-to-cart-button');

  checkbox.addEventListener('change', function () {
    if (checkbox.checked) {
      addToCartButton.disabled = false;  // Enable the button
    } else {
      addToCartButton.disabled = true;   // Disable the button
    }
  });
});



  } catch(e) { console.error(e); }
})();
})();
